import { render, staticRenderFns } from "./ParentsInfo.vue?vue&type=template&id=0471fd0d&"
import script from "./ParentsInfo.vue?vue&type=script&lang=js&"
export * from "./ParentsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports